module.exports = __webpack_public_path__ + "static/media/black_girl_magic.e57cf202.webp";